import React, { useState } from "react";
import DataTable from "react-data-table-component";

export default function DataTable_Component({
  apidata,
  columns,
  searchBy,
  totalRecords,
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,
  search,
  setSearch,
}) {
  const [showFilterModal, setShowFilterModal] = useState(false);

  const applyFilters = () => {
    setShowFilterModal(false);
  };

  const removeFilters = () => {
    setShowFilterModal(false);
  };

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1); // ✅ reset page on search
            }}
          />
        </div>

        <div className="col-md-9 mb-2">
          {/* Filter button kept as is */}
          {/* <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button> */}
        </div>
      </div>

      {apidata.length > 0 ? (
        <DataTable
          columns={columns}
          data={apidata}
          pagination
          fixedHeader
          highlightOnHover
          responsive
          paginationServer
          paginationTotalRows={totalRecords}
          paginationPerPage={rowsPerPage}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
          onChangePage={(page) => setCurrentPage(page)}
          onChangeRowsPerPage={(newPerPage) => {
            setRowsPerPage(newPerPage);
            setCurrentPage(1);
          }}
        />
      ) : (
        <div className="row justify-content-start">
          <div className="col-12">
            <p>No results found.</p>
          </div>
        </div>
      )}
    </div>
  );
}
